import { render, staticRenderFns } from "./studentDetailNew.vue?vue&type=template&id=356f98a2&scoped=true"
import script from "./studentDetailNew.vue?vue&type=script&lang=js"
export * from "./studentDetailNew.vue?vue&type=script&lang=js"
import style0 from "./studentDetailNew.vue?vue&type=style&index=0&id=356f98a2&prod&scoped=true&lang=css"
import style1 from "./studentDetailNew.vue?vue&type=style&index=1&id=356f98a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356f98a2",
  null
  
)

export default component.exports